import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isPremiumUpsellExperimentEnabled = ({
    hasSiteAdministerAccess,
    isHCCustomizationEnabled,
}: {
    hasSiteAdministerAccess?: boolean;
    isHCCustomizationEnabled?: boolean;
}): boolean => {
    if (
        (FeatureGates.checkGate('update_upsell_admin_targeting_in_help_center') && !hasSiteAdministerAccess) ||
        isHCCustomizationEnabled
    ) {
        return false;
    }

    // Main Experiment
    return FeatureGates.getExperimentValue('jsmgrowth-296_improving_premium_upsell_in_portal', 'isEnabled', false);
};
